<template>
  <section class="events__area pt-50 pb-120 p-relative">
    <div class="events__shape">
      <img class="events-1-shape" src="../../assets/img/events/events-shape.png" alt="">
    </div>
    <div class="container">
      <div class="row">
        <div class="col-xxl-12 offset-xxl-12">
          <div class="section__title-wrapper mb-60 text-center">
            <p>{{ $t('event.title') }} {{ events.length }} {{ $t('event.titleThen') }}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div v-for="(vm, index) in events" :key="index" class="col-12">
          <div class="events__item mb-10 hover__active">
            <div class="events__item-inner d-sm-flex align-items-center justify-content-between white-bg">
              <div class="events__content">
                <div class="events__meta">
                  <span>{{ vm.startDate }}</span>
                  <span>9:00 - 15:00</span>
                  <span>{{ vm.address }}</span>
                </div>
                <h3 class="events__title">
                  <router-link :to="`/event-details/${vm.id}`">{{
                      getName({
                        nameLt: vm.titleLt,
                        nameUz: vm.titleUz,
                        nameRu: vm.titleRu,
                        nameEn: vm.titleEn,
                      })
                    }}</router-link>
                </h3>
              </div>
              <div class="events__more">
                <router-link :to="`/event-details/${vm.id}`" class="link-btn">
                  {{ $t('actions.detail') }}
                  <i class="far fa-arrow-right"></i>
                  <i class="far fa-arrow-right"></i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import BlogMixin from '../../mixins/blogMixin';

export default {
  name:'EventArea',
  mixins:[BlogMixin],
  data () {
    return {
      eventsList:[],
      EventData:[
        {
          id:1,
          title:'event.title1',
          date:'Iyul 24, 2025',
          time:'12:00 - 14:30',
          city:'Toshkent'
        },
        {
          id:2,
          title:'event.title2',
          date:'Iyul 26, 2025',
          time:'9:00 - 15:00',
          city:'Toshkent'
        },
        {
          id:3,
          title:'event.title3',
          date:'Avgust 10, 2026',
          time:'10:30 - 13:30',
          city:'Toshkent'
        },
        {
          id:4,
          title:'event.title4',
          date:'Avgust 15, 2025',
          time:'10:30 - 12:00',
          city:'Toshkent'
        },
      ]
    }
  },
  created() {
    this.getEvents()
  },
  computed:{
    ...mapGetters('events', ['events']),
  },
  methods:{
    ...mapActions('events', ['getEvents']),
  }
};
</script>
